// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderItemsListItem_wrapper__4NBil","title":"OrderItemsListItem_title__qbSka","price":"OrderItemsListItem_price__vbdKv"};